/**
 * Route subtree mounted at `/w/:slug/actions` from `App.tsx`. Code-split via
 * `React.lazy` + `<Suspense>` so the frontend-actions bundle stays out of the
 * initial dashboard load. Mirrors `tables/routes.tsx`.
 */

import { lazy, Suspense, type ReactElement } from "react";
import { Route } from "react-router";

import { RouteFallback } from "../components/route-fallback";

const ActionsListPage = lazy(() =>
  import("./pages/ActionsListPage").then((m) => ({ default: m.ActionsListPage })),
);

function withSuspense(node: ReactElement): ReactElement {
  return <Suspense fallback={<RouteFallback />}>{node}</Suspense>;
}

export function clientActionsRoutes() {
  return <Route path="actions" element={withSuspense(<ActionsListPage />)} />;
}
